import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const TermCondition = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Term & Condition</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection wow animate__fadeInDown">
              <h3>App- Terms and Conditions</h3>

              <p>
                <strong>Last Updated: </strong>&nbsp;07 January 2026
              </p>
              <h3>
                <strong>AGREEMENT TO TERMS</strong>
              </h3>
              <p>
                These Terms and Conditions constitute a legally binding
                agreement made between you, whether personally or on behalf of
                an entity (&ldquo;you&rdquo;) and <strong>Hourlee</strong>{" "}
                (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;),
                concerning your access to and use of the{" "}
                <a href="https://hourlee.in/">
                  <strong>https://hourlee.in/</strong>
                </a>{" "}
                &nbsp;website as well as any other media form, media channel,
                mobile website or mobile application related, linked, or
                otherwise connected thereto (collectively, the
                &ldquo;Site&rdquo;).
              </p>
              <p>
                You may also refer to our{" "}
                <strong>User Service Agreement </strong>and{" "}
                <strong>Payment and Refund Policy</strong> for additional terms
                governing your use of the services.
              </p>
              <p>
                Hourlee is a digital employment platform that enables
                individuals to explore, discover, apply for, and engage with job
                opportunities, employers, recruitment services, and
                career-related content.
              </p>
              <p>
                You agree that by accessing the Site, you have read, understood,
                and agree to be bound by all of these Terms and Conditions.
              </p>
              <p>
                IF YOU DO NOT AGREE WITH ALL OF THESE TERMS AND CONDITIONS, THEN
                YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE, AND YOU MUST
                DISCONTINUE USE IMMEDIATELY.
              </p>
              <p>
                Supplemental terms and conditions or documents that may be
                posted on the Site from time to time are hereby expressly
                incorporated herein by reference. We reserve the right, in our
                sole discretion, to make changes or modifications to these Terms
                and Conditions at any time and for any reason.
              </p>
              <p>
                We will alert you about any changes by updating the &ldquo;Last
                updated&rdquo; date of these Terms and Conditions, and you waive
                any right to receive specific notice of each such change.
              </p>
              <p>
                It is your responsibility to periodically review these Terms and
                Conditions to stay informed of updates. You will be subject to,
                and will be deemed to have been made aware of and to have
                accepted, the changes in any revised Terms and Conditions by
                your continued use of the Site after the date such revised Terms
                and Conditions are posted.
              </p>
              <p>
                The information provided on the Site is not intended for
                distribution to or use by any person or entity in any
                jurisdiction or country where such distribution or use would be
                contrary to law or regulation or which would subject us to any
                registration requirement within such jurisdiction or country.
              </p>
              <p>
                Accordingly, those persons who choose to access the Site from
                other locations do so on their own initiative and are solely
                responsible for compliance with local laws, if and to the extent
                local laws are applicable.
              </p>
              <p>
                These Terms and Conditions are based on your provided structure
                and are fully customized for Hourlee.
              </p>
              <p>
                The Site is intended for users who are at least{" "}
                <strong>18 years old</strong>. Persons under the age of 18 are
                not permitted to register for the Site.
              </p>
              <h3>
                <strong>INTELLECTUAL PROPERTY RIGHTS</strong>
              </h3>
              <p>
                Unless otherwise indicated, the Site is our proprietary property
                and all source code, databases, functionality, software, website
                designs, audio, video, text, photographs, and graphics on the
                Site (collectively, the &ldquo;Content&rdquo;) and the
                trademarks, service marks, and logos contained therein (the
                &ldquo;Marks&rdquo;) are owned or controlled by us or licensed
                to us, and are protected by copyright and trademark laws and
                various other intellectual property rights and unfair
                competition laws of India, foreign jurisdictions, and
                international conventions.
              </p>
              <p>
                The Content and the Marks are provided on the Site &ldquo;AS
                IS&rdquo; for your information and personal use only. Except as
                expressly provided in these Terms and Conditions, no part of the
                Site and no Content or Marks may be copied, reproduced,
                aggregated, republished, uploaded, posted, publicly displayed,
                encoded, translated, transmitted, distributed, sold, licensed,
                or otherwise exploited for any commercial purpose whatsoever,
                without our express prior written permission.
              </p>
              <p>
                Provided that you are eligible to use the Site, you are granted
                a limited license to access and use the Site and to download or
                print a copy of any portion of the Content to which you have
                properly gained access solely for your personal, non-commercial
                use. We reserve all rights not expressly granted to you in and
                to the Site, the Content, and the Marks.
              </p>
              <h3>
                <strong>USER REPRESENTATIONS</strong>
              </h3>
              <p>By using the Site, you represent and warrant that:</p>
              <p>
                (1) All registration information you submit will be true,
                accurate, current, and complete;
                <br /> &nbsp;(2) You will maintain the accuracy of such
                information and promptly update such registration information as
                necessary;
                <br /> &nbsp;(3) You have the legal capacity, and you agree to
                comply with these Terms and Conditions;
                <br /> &nbsp;(4) You are not under the age of 18;
                <br /> &nbsp;(5) You will not access the Site through automated
                or non-human means, whether through a bot, script, or otherwise;
                <br /> &nbsp;(6) You will not use the Site for any illegal or
                unauthorized purpose;
                <br /> &nbsp;(7) Your use of the Site will not violate any
                applicable law or regulation.
              </p>
              <p>
                If you provide any information that is untrue, inaccurate, not
                current, or incomplete, we have the right to suspend or
                terminate your account and refuse any and all current or future
                use of the Site (or any portion thereof).
              </p>
              <h3>
                <strong>USER REGISTRATION</strong>
              </h3>
              <p>
                You may be required to register with the Site. You agree to keep
                your password confidential and will be responsible for all use
                of your account and password. We reserve the right to remove,
                reclaim, or change a username you select if we determine, in our
                sole discretion, that such username is inappropriate, obscene,
                or otherwise objectionable.
              </p>
              <p>
                <strong>PROHIBITED ACTIVITIES</strong>
              </p>
              <p>
                You may not access or use the Site for any purpose other than
                that for which we make the Site available. The Site may not be
                used in connection with any commercial endeavors except those
                that are specifically endorsed or approved by us.
              </p>
              <p>As a user of the Site, you agree not to:</p>
              <ul>
                <li>
                  Systematically retrieve data or other content from the Site to
                  create or compile, directly or indirectly, a collection,
                  compilation, database, or directory without written permission
                  from us.
                  <br />{" "}
                </li>
                <li>
                  Make any unauthorized use of the Site, including collecting
                  usernames and/or email addresses of users by electronic or
                  other means for the purpose of sending unsolicited email, or
                  creating user accounts by automated means or under false
                  pretenses.
                  <br />{" "}
                </li>
                <li>
                  Use a buying agent or purchasing agent to make purchases on
                  the Site.
                  <br />{" "}
                </li>
                <li>
                  Use the Site to advertise or offer to sell goods and services.
                  <br />{" "}
                </li>
                <li>
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the Site, including features that
                  prevent or restrict the use or copying of any Content or
                  enforce limitations on the use of the Site and/or the Content
                  contained therein.
                  <br />{" "}
                </li>
                <li>
                  Engage in unauthorized framing of or linking to the Site.
                  <br />{" "}
                </li>
                <li>
                  Trick, defraud, or mislead other users, especially in any
                  attempt to learn sensitive account information such as user
                  passwords.
                  <br />{" "}
                </li>
                <li>
                  Make improper use of our support services or submit false
                  reports of abuse or misconduct.
                  <br />{" "}
                </li>
                <li>
                  Engage in any automated use of the system, such as using
                  scripts to send comments or messages, or using any data
                  mining, robots, or similar data gathering and extraction
                  tools.
                  <br />{" "}
                </li>
                <li>
                  Interfere with, disrupt, or create an undue burden on the Site
                  or the networks or services connected to the Site.
                  <br />{" "}
                </li>
                <li>
                  Attempt to impersonate another user or person, or use the
                  username of another user.
                  <br />{" "}
                </li>
                <li>
                  Sell or otherwise transfer your profile.
                  <br />{" "}
                </li>
                <li>
                  Use any information obtained from the Site in order to harass,
                  abuse, or harm another person.
                  <br />{" "}
                </li>
                <li>
                  Use the Site as part of any effort to compete with us or
                  otherwise use the Site and/or the Content for any
                  revenue-generating endeavor or commercial enterprise.
                  <br />{" "}
                </li>
                <li>
                  Decipher, decompile, disassemble, or reverse engineer any of
                  the software comprising or in any way making up a part of the
                  Site.
                  <br />{" "}
                </li>
                <li>
                  Attempt to bypass any measures of the Site designed to prevent
                  or restrict access to the Site, or any portion of the Site.
                  <br />{" "}
                </li>
                <li>
                  Harass, annoy, intimidate, or threaten any of our employees or
                  agents engaged in providing any portion of the Site to you.
                  <br />{" "}
                </li>
                <li>
                  Delete the copyright or other proprietary rights notice from
                  any Content.
                  <br />{" "}
                </li>
                <li>
                  Copy or adapt the Site&rsquo;s software, including but not
                  limited to Flash, PHP, HTML, JavaScript, or other code.
                  <br />{" "}
                </li>
                <li>
                  Upload or transmit (or attempt to upload or transmit) viruses,
                  Trojan horses, or other material, including excessive use of
                  capital letters and spamming, that interferes with any
                  party&rsquo;s uninterrupted use and enjoyment of the Site or
                  modifies or disrupts the Site&rsquo;s operation.
                  <br />{" "}
                </li>
                <li>
                  Upload or transmit any material that acts as a passive or
                  active information collection or transmission mechanism,
                  including, without limitation, GIFs, 1&times;1 pixels, web
                  bugs, cookies, or similar devices.
                  <br />{" "}
                </li>
                <li>
                  Except as may be the result of standard search engine or
                  Internet browser usage, use or launch any automated system,
                  including any spider, robot, cheat utility, scraper, or
                  offline reader that accesses the Site, or use or launch any
                  unauthorized script or software.
                  <br />{" "}
                </li>
                <li>
                  Disparage, tarnish, or otherwise harm, in our opinion, us
                  and/or the Site.
                  <br />{" "}
                </li>
                <li>
                  Use the Site in a manner inconsistent with any applicable laws
                  or regulations.
                  <br />{" "}
                </li>
                <li>[other]</li>
              </ul>
              <h3>
                <strong>USER-GENERATED CONTRIBUTIONS</strong>
              </h3>
              <p>
                The Site may invite you to chat, contribute to, or participate
                in blogs, message boards, online forums, and other
                functionality, and may provide you with the opportunity to
                create, submit, post, display, transmit, perform, publish,
                distribute, or broadcast content and materials to us or on the
                Site, including but not limited to text, writings, video, audio,
                photographs, graphics, comments, suggestions, or personal
                information or other material (collectively,
                &ldquo;Contributions&rdquo;).
              </p>
              <p>
                Contributions may be viewable by other users of the Site and
                through third-party websites. As such, any Contributions you
                transmit may be treated as non-confidential and non-proprietary.
                When you create or make available any Contributions, you thereby
                represent and warrant that:
              </p>
              <ol>
                <li>
                  <strong>
                    The creation, distribution, transmission, public display, or
                    performance, and the accessing, downloading, or copying of
                    your Contributions do not and will not infringe the
                    proprietary rights
                  </strong>
                  , including but not limited to the copyright, patent,
                  trademark, trade secret, or moral rights of any third party.
                  <br />{" "}
                </li>
                <li>
                  <strong>
                    You are the creator and owner of, or have the necessary
                    licenses, rights, consents, releases, and permissions
                  </strong>{" "}
                  to use and to authorize us, the Site, and other users of the
                  Site to use your Contributions in any manner contemplated by
                  the Site and these Terms and Conditions.
                  <br />{" "}
                </li>
                <li>
                  <strong>
                    You have the written consent, release, and/or permission of
                    every identifiable individual person
                  </strong>{" "}
                  in your Contributions to use the name or likeness of each such
                  individual.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions are not false, inaccurate, or misleading.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions are not unsolicited or unauthorized
                  advertising, promotional materials, pyramid schemes, chain
                  letters, spam, mass mailings, or other forms of solicitation.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions are not obscene, lewd, lascivious, filthy,
                  violent, harassing, libelous, slanderous, or otherwise
                  objectionable (as determined by us).
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not ridicule, mock, disparage,
                  intimidate, or abuse anyone.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not advocate the violent overthrow of
                  any government or incite, encourage, or threaten physical harm
                  against another.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not violate any applicable law,
                  regulation, or rule.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not violate the privacy or publicity
                  rights of any third party.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not contain any material that solicits
                  personal information from anyone under the age of 18 or
                  exploits people under 18 in a sexual or violent manner.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not violate any laws concerning child
                  pornography or intended to protect minors&rsquo; welfare.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not include offensive comments linked to
                  race, national origin, gender, sexual preference, or physical
                  handicap.
                  <br />{" "}
                </li>
                <li>
                  Your Contributions do not otherwise violate, or link to
                  material that violates, any provision of these Terms and
                  Conditions or any applicable law.
                  <br />{" "}
                </li>
              </ol>
              <p>
                Any use of the Site in violation of the foregoing may result in
                termination or suspension of your rights to use the Site.
              </p>
              <h3>
                <strong>CONTRIBUTION LICENSE</strong>
              </h3>
              <p>
                By posting your Contributions to any part of the Site or making
                Contributions accessible to the Site by linking your account
                from any of your social networking accounts, you automatically
                grant us an unrestricted, unlimited, irrevocable, perpetual,
                non-exclusive, transferable, royalty-free, fully paid, worldwide
                right and license to:
              </p>
              <ul>
                <li>
                  host,
                  <br />{" "}
                </li>
                <li>
                  use,
                  <br />{" "}
                </li>
                <li>
                  copy,
                  <br />{" "}
                </li>
                <li>
                  reproduce,
                  <br />{" "}
                </li>
                <li>
                  disclose,
                  <br />{" "}
                </li>
                <li>
                  sell,
                  <br />{" "}
                </li>
                <li>
                  resell,
                  <br />{" "}
                </li>
                <li>
                  publish,
                  <br />{" "}
                </li>
                <li>
                  broadcast,
                  <br />{" "}
                </li>
                <li>
                  retitle,
                  <br />{" "}
                </li>
                <li>
                  archive,
                  <br />{" "}
                </li>
                <li>
                  store,
                  <br />{" "}
                </li>
                <li>
                  cache,
                  <br />{" "}
                </li>
                <li>
                  publicly perform,
                  <br />{" "}
                </li>
                <li>
                  publicly display,
                  <br />{" "}
                </li>
                <li>
                  reformat,
                  <br />{" "}
                </li>
                <li>
                  translate,
                  <br />{" "}
                </li>
                <li>
                  transmit,
                  <br />{" "}
                </li>
                <li>
                  excerpt (in whole or in part),
                  <br />{" "}
                </li>
                <li>
                  And distribute such Contributions for any purpose, commercial
                  or otherwise.
                  <br />{" "}
                </li>
              </ul>
              <p>
                This includes incorporating Contributions into other works,
                preparing derivative works, and sublicensing these rights.
              </p>
              <p>
                This license applies to any form, media, or technology now known
                or hereafter developed.
              </p>
              <p>You waive all moral rights in your Contributions.</p>
              <p>
                We do not assert ownership over your Contributions. You retain
                full ownership and all intellectual property rights to your
                Contributions. However, by submitting them, you agree not to
                take any action against us regarding them.
              </p>
              <p>We may, in our sole discretion:</p>
              <ul>
                <li>
                  Edit, redact, or otherwise change Contributions;
                  <br />{" "}
                </li>
                <li>
                  Re-categorize Contributions;
                  <br />{" "}
                </li>
                <li>
                  Pre-screen or delete Contributions at any time and for any
                  reason.
                  <br />{" "}
                </li>
              </ul>
              <p>We have no obligation to monitor Contributions.</p>
              <h3>
                <strong>GUIDELINES FOR REVIEWS</strong>
              </h3>
              <p>
                We may allow you to leave reviews or ratings. When posting a
                review, you agree that:
              </p>
              <ol>
                <li>
                  You must have firsthand experience with the person/entity
                  being reviewed.
                  <br />{" "}
                </li>
                <li>
                  Your review must not contain profanity, abusive, or hateful
                  language.
                  <br />{" "}
                </li>
                <li>
                  Your review must not contain discriminatory comments.
                  <br />{" "}
                </li>
                <li>
                  Your review must not reference illegal activities.
                  <br />{" "}
                </li>
                <li>
                  You must not be affiliated with competitors when posting
                  negative reviews.
                  <br />{" "}
                </li>
                <li>
                  You must not make legal conclusions.
                  <br />{" "}
                </li>
                <li>
                  You must not post false or misleading statements.
                  <br />{" "}
                </li>
                <li>
                  You must not organize or encourage campaigns to influence
                  reviews.
                  <br />{" "}
                </li>
              </ol>
              <p>
                We may accept, reject, or remove reviews at our discretion. We
                have <strong>no obligation</strong> to screen or delete reviews.
              </p>
              <p>
                Reviews do not represent our opinions or those of any affiliate
                or partner.
              </p>
              <p>
                You grant us a perpetual, non-exclusive, worldwide, royalty-free
                license to reproduce, modify, translate, transmit, display,
                perform, and distribute all review-related content.
              </p>
              <h3>
                <strong>MOBILE APPLICATION LICENSE</strong>
              </h3>
              <p>
                If you access the Site via a mobile application, we grant you a{" "}
                <strong>
                  revocable, non-exclusive, non-transferable, limited right
                </strong>{" "}
                to install and use the mobile application on wireless electronic
                devices owned or controlled by you.
              </p>
              <p>You may not:</p>
              <ol>
                <li>
                  Decompile, reverse engineer, disassemble, attempt to derive
                  the source code of, or decrypt the application;
                  <br />{" "}
                </li>
                <li>
                  Make any modification, adaptation, improvement, enhancement,
                  translation, or derivative work;
                  <br />{" "}
                </li>
                <li>
                  Violate any applicable laws in connection with your use of the
                  application;
                  <br />{" "}
                </li>
                <li>
                  Remove, alter, or obscure any proprietary notice;
                  <br />{" "}
                </li>
                <li>
                  Use it for commercial purposes not intended by us;
                  <br />{" "}
                </li>
                <li>
                  Make the application available over a network, allowing
                  multiple devices or users to access it;
                  <br /> Create a competing product or service.
                  <br />{" "}
                </li>
                <li>
                  Use it for automated queries or unsolicited emails.
                  <br />{" "}
                </li>
                <li>
                  Use our proprietary information for the development of
                  competing applications or devices.
                  <br />{" "}
                </li>
              </ol>
              <p>
                <strong>APPLE AND ANDROID DEVICES</strong>
              </p>
              <p>
                The following applies when accessing the Site via an application
                obtained from the Apple App Store or Google Play Store:
              </p>
              <ol>
                <li>
                  The license is limited to a non-transferable license on a
                  device that uses Apple iOS or Android OS.
                  <br />{" "}
                </li>
                <li>
                  We are responsible for providing maintenance/support services
                  where required by applicable law; App Distributors are not
                  obligated to provide any support.
                  <br />{" "}
                </li>
                <li>
                  If the mobile app fails to conform to any warranty, you may
                  notify the App Distributor, who may refund the purchase price
                  if applicable.
                  <br />{" "}
                </li>
                <li>
                  You represent and warrant that you are not in a country
                  subject to a U.S. embargo nor listed on any U.S.
                  prohibited-party list.
                  <br />{" "}
                </li>
                <li>
                  You must comply with third-party terms when using the
                  application.
                  <br />{" "}
                </li>
                <li>
                  App Distributors are third-party beneficiaries and may enforce
                  these Terms against you.
                </li>
              </ol>
              <p>&nbsp;</p>
              <h3>
                <strong>SOCIAL MEDIA</strong>
              </h3>
              <p>
                As part of the functionality of the Site, you may link your
                account with online accounts you have with third-party service
                providers (each such account, a &ldquo;Third-Party
                Account&rdquo;) by either:
                <br /> &nbsp;(1) providing your Third-Party Account login
                information through the Site; or
                <br /> &nbsp;(2) allowing us to access your Third-Party Account,
                as is permitted under the applicable terms and conditions that
                govern your use of each Third-Party Account.
              </p>
              <p>
                You represent and warrant that you are entitled to disclose your
                Third-Party Account login information to us and/or grant us
                access to your Third-Party Account,{" "}
                <strong>without breach of any terms and conditions</strong>{" "}
                governing the use of the Third-Party Account, and without
                obligating us to pay any fees or subjecting us to any usage
                limitations.
              </p>
              <p>
                By granting us access to your Third-Party Accounts, you
                acknowledge and agree that:
              </p>
              <ol>
                <li>
                  We may access, make available, and store (if applicable){" "}
                  <strong>any content</strong> you have stored in your
                  Third-Party Account (&ldquo;Social Network Content&rdquo;) so
                  it is available through the Site;
                  <br />{" "}
                </li>
                <li>
                  We may submit to and receive from your Third-Party Account
                  additional information to the extent you are notified when you
                  link your account.
                  <br />{" "}
                </li>
              </ol>
              <p>
                Depending on the Third-Party Accounts you choose and subject to
                their privacy settings,{" "}
                <strong>personally identifiable information</strong> posted to
                those accounts may be available through the Site.
              </p>
              <p>
                If a Third-Party Account becomes unavailable or access is
                terminated by the provider, Social Network Content may no longer
                be accessible. You may disable the connection between your
                Hourlee account and a Third-Party Account at any time.
              </p>
              <p>
                PLEASE NOTE:
                <br /> &nbsp;Your relationship with each Third-Party provider is
                governed <strong>solely</strong> by your agreements with them.
                <br /> &nbsp;We are not responsible for Social Network Content
                and make no effort to review it for any purpose.
              </p>
              <p>
                We may access your email address book or contacts list solely
                for identifying and notifying you of contacts who also use the
                Site.
              </p>
              <p>
                You may deactivate Third-Party account integrations at any time
                through your account settings or by contacting us.
              </p>
              <p>
                We will attempt to delete stored information obtained from such
                Third-Party Accounts, except the username and profile picture
                associated with your Hourlee account.
              </p>
              <h3>
                <strong>SUBMISSIONS</strong>
              </h3>
              <p>
                You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback, or other information that you
                provide to us regarding the Site (&ldquo;Submissions&rdquo;) are{" "}
                <strong>non-confidential</strong> and shall become our sole
                property.
              </p>
              <p>
                We shall own exclusive rights, including all intellectual
                property rights, and shall be entitled to:
              </p>
              <ul>
                <li>
                  unrestricted use,
                  <br />{" "}
                </li>
                <li>
                  dissemination,
                  <br />{" "}
                </li>
                <li>
                  modification,
                  <br />{" "}
                </li>
                <li>
                  reproduction,
                  <br />{" "}
                </li>
                <li>
                  commercial exploitation,
                  <br />{" "}
                </li>
              </ul>
              <p>
                Of such Submissions for any lawful purpose,{" "}
                <strong>without acknowledgment or compensation</strong> to you.
              </p>
              <p>
                You waive all moral rights to such Submissions and warrant that:
              </p>
              <ul>
                <li>
                  They are original to you, or
                  <br />{" "}
                </li>
                <li>
                  You have the right to submit them.
                  <br />{" "}
                </li>
              </ul>
              <p>
                You agree you will not take any legal action against us for any
                alleged or actual infringement or misappropriation of
                proprietary rights in your Submissions.
              </p>
              <h3>
                <strong>THIRD-PARTY WEBSITES AND CONTENT</strong>
              </h3>
              <p>
                The Site may contain (or you may be sent via the Site) links to
                third-party websites (&ldquo;Third-Party Websites&rdquo;) or
                content belonging to third parties (&ldquo;Third-Party
                Content&rdquo;).
              </p>
              <p>
                We do not investigate, monitor, or check Third-Party Websites or
                Content for accuracy, appropriateness, or completeness.
              </p>
              <p>We are not responsible for:</p>
              <ul>
                <li>
                  Any Third-Party Websites accessed via the Site,
                  <br />{" "}
                </li>
                <li>
                  any Third-Party Content posted on, available through, or
                  installed from the Site, including
                  <br /> <br />
                  <ul>
                    <li>
                      content,
                      <br />{" "}
                    </li>
                    <li>
                      accuracy,
                      <br />{" "}
                    </li>
                    <li>
                      offensiveness,
                      <br />{" "}
                    </li>
                    <li>
                      opinions,
                      <br />{" "}
                    </li>
                    <li>
                      reliability,
                      <br />{" "}
                    </li>
                    <li>
                      privacy practices, or
                      <br />{" "}
                    </li>
                    <li>
                      Other policies.
                      <br />{" "}
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                Links or permissions to use/install Third-Party Websites or
                Content do not imply approval or endorsement by us.
              </p>
              <p>
                If you leave the Site and access Third-Party Websites or
                install/use Third-Party Content, you do so{" "}
                <strong>at your own risk</strong>.
              </p>
              <p>
                You must review the terms, policies, and privacy practices of
                any Third-Party Website you visit.
              </p>
              <p>
                Purchases made through Third-Party Websites are solely between
                you and the applicable third party.
                <br /> &nbsp;We accept <strong>no liability</strong> regarding
                such purchases.
              </p>
              <p>
                You agree we are not responsible for harm caused by your
                purchase or interaction with Third-Party Websites or Content.
                <br /> &nbsp;You also agree to hold us harmless from any losses
                related to or resulting from Third-Party Content or contact with
                Third-Party Websites.
              </p>
              <h3>
                <strong>ADVERTISERS</strong>
              </h3>
              <p>
                We allow advertisers to display ads in certain areas of the Site
                (e.g., sidebar, banners).
              </p>
              <p>
                If you are an advertiser, you take{" "}
                <strong>full responsibility</strong> for:
              </p>
              <ul>
                <li>
                  Advertisements you place,
                  <br />{" "}
                </li>
                <li>
                  services provided through those advertisements,
                  <br />{" "}
                </li>
                <li>
                  Products are sold through those advertisements.
                  <br />{" "}
                </li>
              </ul>
              <p>As an advertiser, you represent and warrant that you have:</p>
              <ul>
                <li>
                  All rights and authority to place advertisements on the Site,
                  including
                  <br /> <br />
                  <ul>
                    <li>
                      intellectual property rights,
                      <br />{" "}
                    </li>
                    <li>
                      publicity rights,
                      <br />{" "}
                    </li>
                    <li>
                      Contractual rights.
                      <br />{" "}
                    </li>
                  </ul>
                </li>
              </ul>
              <p>We simply provide advertising space.</p>
              <h3>
                <strong>SITE MANAGEMENT</strong>
              </h3>
              <p>We reserve the right, but not the obligation, to:</p>
              <ol>
                <li>
                  Monitor the Site for violations of these Terms;
                  <br />{" "}
                </li>
                <li>
                  Take legal action against violators (including reporting to
                  authorities);
                  <br />{" "}
                </li>
                <li>
                  Refuse, restrict access to, limit availability of, or disable
                  any Contributions;
                  <br />{" "}
                </li>
                <li>
                  Remove or disable files/content that are excessive in size or
                  burdensome to systems;
                  <br />{" "}
                </li>
                <li>
                  Manage the Site in a way designed to protect our rights and
                  ensure proper functioning.
                  <br />{" "}
                </li>
              </ol>
              <h3>
                <strong>PRIVACY POLICY</strong>
              </h3>
              <p>
                We care about data privacy and security. Please review our
                Privacy Policy posted on the Site.
                <br /> By using the Site, you agree to be bound by our Privacy
                Policy, which is incorporated into these Terms and Conditions.
              </p>
              <h3>
                <strong>COPYRIGHT INFRINGEMENTS</strong>
              </h3>
              <p>
                We respect intellectual property rights. If you believe that
                material on the Site infringes your copyright, notify us using
                the contact information below.
              </p>
              <p>False claims may result in liability for damages.</p>
              <h3>
                <strong>TERM AND TERMINATION</strong>
              </h3>
              <p>
                These Terms and Conditions shall remain in full force and effect
                while you use the Site.
              </p>
              <p>
                WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS AND
                CONDITIONS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
                WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE
                (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY
                REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH
                OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE
                TERMS AND CONDITIONS OR OF ANY APPLICABLE LAW OR REGULATION.
              </p>
              <p>
                WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE
                YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT
                ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
              </p>
              <p>
                If we terminate or suspend your account for any reason, you are{" "}
                <strong>
                  prohibited from registering and creating a new account
                </strong>{" "}
                under your name, a fake name, a nickname, or the name of any
                third party, even if you are acting on behalf of the third
                party.
              </p>
              <p>
                In addition to terminating or suspending your account, we
                reserve the right to pursue civil, criminal, and injunctive
                relief.
              </p>
              <h3>
                <strong>MODIFICATIONS AND INTERRUPTIONS</strong>
              </h3>
              <p>
                We reserve the right to change, modify, or remove the content of
                the Site at any time or for any reason in our sole discretion
                without notice.
              </p>
              <p>
                We have no obligation to update any information on the Site.
              </p>
              <p>
                We also reserve the right to modify or discontinue all or part
                of the Site without notice at any time.
              </p>
              <p>
                We shall not be liable to you or any third party for any
                modification, price change, suspension, or discontinuance of the
                Site.
              </p>
              <p>
                We cannot guarantee the Site will be available at all times. We
                may experience:
              </p>
              <ul>
                <li>
                  hardware issues
                  <br />{" "}
                </li>
                <li>
                  software issues
                  <br />{" "}
                </li>
                <li>
                  maintenance delays
                  <br />{" "}
                </li>
                <li>
                  outages
                  <br />{" "}
                </li>
                <li>
                  interruptions
                  <br />{" "}
                </li>
                <li>
                  errors
                  <br />{" "}
                </li>
              </ul>
              <p>This may result in the Site being unavailable.</p>
              <p>
                You agree we have no liability whatsoever for any loss, damage,
                or inconvenience caused by:
              </p>
              <ul>
                <li>
                  Your inability to access the Site during downtime, or
                  <br />{" "}
                </li>
                <li>
                  The discontinuance of the Site.
                  <br />{" "}
                </li>
              </ul>
              <p>Nothing in these Terms obligates us to:</p>
              <ul>
                <li>
                  Maintain the Site,
                  <br />{" "}
                </li>
                <li>
                  Update the Site,
                  <br />{" "}
                </li>
                <li>
                  issue corrections, or
                  <br />{" "}
                </li>
                <li>
                  Provide upgrades or enhancements.
                  <br />{" "}
                </li>
              </ul>
              <h3>
                <strong>GOVERNING LAW</strong>
              </h3>
              <p>
                These Terms and Conditions and your use of the Site are governed
                by and construed in accordance with the laws of{" "}
                <strong>India</strong>, without regard to conflict of law
                principles.
              </p>
              <p>
                Any disputes arising from these Terms shall be brought
                exclusively before courts located in{" "}
                <strong>Delhi, India</strong>, and you hereby consent to such
                jurisdiction.
              </p>
              <h3>
                <strong>DISPUTE RESOLUTION</strong>
              </h3>
              <h2>
                <strong>Court Proceedings</strong>
              </h2>
              <h2>
                Any legal action brought by either you or us shall be commenced
                or prosecuted in the courts located within:
              </h2>
              <p>
                <strong>Delhi, India</strong>
              </p>
              <p>
                And the Parties hereby consent to and waive all defenses of lack
                of personal jurisdiction and forum non conveniens with respect
                to such courts.
              </p>
              <h3>
                <strong>CORRECTIONS</strong>
              </h3>
              <p>There may be information on the Site that contains:</p>
              <ul>
                <li>
                  typographical errors,
                  <br />{" "}
                </li>
                <li>
                  inaccuracies, or
                  <br />{" "}
                </li>
                <li>
                  omissions,
                  <br />{" "}
                </li>
              </ul>
              <p>Including:</p>
              <ul>
                <li>
                  descriptions,
                  <br />{" "}
                </li>
                <li>
                  pricing,
                  <br />{" "}
                </li>
                <li>
                  availability, and
                  <br />{" "}
                </li>
                <li>
                  Other information.
                  <br />{" "}
                </li>
              </ul>
              <p>
                We reserve the right to correct any errors or omissions and to
                change/update information at any time, without prior notice.
              </p>
              <h3>
                <strong>DISCLAIMER</strong>
              </h3>
              <p>
                THE SITE IS PROVIDED ON AN &ldquo;AS-IS&rdquo; AND
                &ldquo;AS-AVAILABLE&rdquo; BASIS. YOU AGREE THAT YOUR USE OF THE
                SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK.
              </p>
              <p>
                TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL
                WARRANTIES, EXPRESS OR IMPLIED, INCLUDING:
              </p>
              <ul>
                <li>
                  MERCHANTABILITY,
                  <br />{" "}
                </li>
                <li>
                  FITNESS FOR A PARTICULAR PURPOSE,
                  <br />{" "}
                </li>
                <li>
                  NON-INFRINGEMENT.
                  <br />{" "}
                </li>
              </ul>
              <p>WE MAKE NO WARRANTIES ABOUT:</p>
              <ol>
                <li>
                  Errors, inaccuracies, or omissions in content;
                  <br />{" "}
                </li>
                <li>
                  Personal injury or property damage resulting from Site use;
                  <br />{" "}
                </li>
                <li>
                  Unauthorized access to or use of secure servers and/or
                  personal or financial data;
                  <br />{" "}
                </li>
                <li>
                  Interruption of transmission to/from the Site;
                  <br />{" "}
                </li>
                <li>
                  Bugs, viruses, trojans, or the like transmitted through the
                  Site;
                  <br />{" "}
                </li>
                <li>
                  Loss or damage of any kind due to content posted, transmitted,
                  or otherwise made available via the Site.
                  <br />{" "}
                </li>
              </ol>
              <p>
                We do not endorse, guarantee, or assume responsibility for any
                product or service advertised or offered by a third party via
                the Site.
              </p>
              <p>
                You must use judgment and exercise caution when dealing with
                third-party content or services.
              </p>
              <h3>
                <strong>LIMITATIONS OF LIABILITY</strong>
              </h3>
              <p>
                IN NO EVENT SHALL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                LIABLE TO YOU OR ANY THIRD PARTY FOR ANY:
              </p>
              <ul>
                <li>
                  DIRECT,
                  <br />{" "}
                </li>
                <li>
                  INDIRECT,
                  <br />{" "}
                </li>
                <li>
                  CONSEQUENTIAL,
                  <br />{" "}
                </li>
                <li>
                  EXEMPLARY,
                  <br />{" "}
                </li>
                <li>
                  INCIDENTAL,
                  <br />{" "}
                </li>
                <li>
                  SPECIAL, OR
                  <br />{" "}
                </li>
                <li>
                  PUNITIVE DAMAGES,
                  <br />{" "}
                </li>
              </ul>
              <p>INCLUDING:</p>
              <ul>
                <li>
                  lost profits,
                  <br />{" "}
                </li>
                <li>
                  lost revenue,
                  <br />{" "}
                </li>
                <li>
                  loss of data,
                  <br />{" "}
                </li>
                <li>Or other damages arising from your use of the Site.</li>
              </ul>
              <h3>
                <strong>INDEMNIFICATION</strong>
              </h3>
              <p>
                You agree to{" "}
                <strong>defend, indemnify, and hold us harmless</strong>,
                including our subsidiaries, affiliates, and all of our
                respective officers, agents, partners, and employees, from and
                against{" "}
                <strong>any loss, damage, liability, claim, or demand</strong>,
                including reasonable attorneys&rsquo; fees and expenses, made by
                any third party due to or arising out of:
              </p>
              <ol>
                <li>
                  <strong>Your Contributions</strong>;<br />{" "}
                </li>
                <li>
                  your use of the Site;
                  <br />{" "}
                </li>
                <li>
                  your breach of these Terms and Conditions;
                  <br />{" "}
                </li>
                <li>
                  Any breach of your representations and warranties set forth in
                  these Terms and Conditions;
                  <br />{" "}
                </li>
                <li>
                  your violation of the rights of a third party, including but
                  not limited to intellectual property rights;
                  <br />{" "}
                </li>
                <li>
                  Any overt harmful act toward any other user of the Site with
                  whom you connected via the Site.
                  <br />{" "}
                </li>
              </ol>
              <p>
                Notwithstanding the above, we reserve the right&mdash;
                <strong>at your expense</strong>&mdash;to assume the exclusive
                defense and control of any matter for which you are required to
                indemnify us.
              </p>
              <p>
                You agree to fully cooperate, at your expense, with our defense
                of any claim.
              </p>
              <p>
                We will use reasonable efforts to notify you of any claim,
                action, or proceeding subject to this indemnification clause
                once we become aware of it.
              </p>
              <h3>
                <strong>USER DATA</strong>
              </h3>
              <p>
                We will maintain certain data that you transmit to the Site for
                the purpose of managing the Site, as well as data relating to
                your use of the Site.
              </p>
              <p>
                Although we perform regular routine backups of data,{" "}
                <strong>you are solely responsible</strong> for all data you
                transmit or that relates to any activity you undertake using the
                Site.
              </p>
              <p>You agree that:</p>
              <ul>
                <li>
                  We shall have <strong>no liability</strong> for any loss or
                  corruption of such data, and
                  <br />{" "}
                </li>
                <li>
                  You hereby waive any right of action against us arising from
                  any such loss or corruption of data.
                  <br />{" "}
                </li>
              </ul>
              <h3>
                <strong>
                  ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
                </strong>
              </h3>
              <p>
                Visiting the Site, sending us emails, and completing online
                forms constitute &ldquo;electronic communications.&rdquo;
              </p>
              <p>
                You consent to receive electronic communications and agree that:
              </p>
              <ul>
                <li>
                  all agreements,
                  <br />{" "}
                </li>
                <li>
                  notices,
                  <br />{" "}
                </li>
                <li>
                  disclosures,
                  <br />{" "}
                </li>
                <li>
                  And other communications we provide electronically
                  <br />{" "}
                </li>
              </ul>
              <p>
                <strong>
                  Satisfy any legal requirement that such communication be in
                  writing.
                </strong>
              </p>
              <p>YOU HEREBY AGREE TO THE USE OF:</p>
              <ul>
                <li>
                  electronic signatures,
                  <br />{" "}
                </li>
                <li>
                  electronic contracts,
                  <br />{" "}
                </li>
                <li>
                  electronic orders, and
                  <br />{" "}
                </li>
                <li>
                  Electronic delivery of notices, policies, and records of
                  transactions.
                  <br />{" "}
                </li>
              </ul>
              <p>
                You hereby waive any rights or requirements under any statute or
                law that require:
              </p>
              <ul>
                <li>
                  An original signature,
                  <br />{" "}
                </li>
                <li>
                  delivery or retention of non-electronic records, or
                  <br />{" "}
                </li>
                <li>
                  Payment or credit by non-electronic means.
                  <br />{" "}
                </li>
              </ul>
              <h3>
                <strong>MISCELLANEOUS</strong>
              </h3>
              <p>
                These Terms and Conditions and any policies or operating rules
                posted by us on the Site constitute the{" "}
                <strong>entire agreement and understanding</strong> between you
                and us.
              </p>
              <p>
                Our failure to exercise or enforce any right or provision shall
                not operate as a waiver of such right or provision.
              </p>
              <p>
                These Terms and Conditions operate to the{" "}
                <strong>fullest extent permitted by law</strong>.
              </p>
              <p>
                We may assign <strong>any or all</strong> of our rights and
                obligations to others at any time.
              </p>
              <p>We are not responsible or liable for any:</p>
              <ul>
                <li>
                  loss,
                  <br />{" "}
                </li>
                <li>
                  damage,
                  <br />{" "}
                </li>
                <li>
                  delay,
                  <br />{" "}
                </li>
                <li>
                  or failure to act
                  <br />{" "}
                </li>
              </ul>
              <p>Caused by circumstances beyond our reasonable control.</p>
              <p>
                If any provision or part of a provision of these Terms is
                determined to be unlawful, void, or unenforceable:
              </p>
              <ul>
                <li>
                  That provision or part shall be severed, and
                  <br />{" "}
                </li>
                <li>
                  The remaining provisions remain in full force and effect.
                  <br />{" "}
                </li>
              </ul>
              <p>
                There is{" "}
                <strong>
                  no joint venture, partnership, employment, or agency
                  relationship
                </strong>{" "}
                created between you and us as a result of these Terms or your
                use of the Site.
              </p>
              <p>
                You agree that these Terms will not be construed against us
                merely because we drafted them.
              </p>
              <p>
                You waive any defenses based on the electronic form of these
                Terms and the absence of a physical signature.
              </p>
              <h3>
                <strong>CONTACT US</strong>
              </h3>
              <p>
                In order to resolve a complaint regarding the Site or to receive
                further information regarding the use of the Site, please
                contact us at:
              </p>
              <p>
                <strong>Hourlee </strong>
              </p>
              <p>
                <strong>
                  RightO Services Private Ltd. (Hourlee)
                  <br /> Address: 52/1 Park Road, Dehradun - 248001, India
                  <br /> <br /> Phone: 9811999641
                </strong>
              </p>
              <p>
                <strong>Email: Contact@hourlee.in</strong>
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default TermCondition;
